const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8005';

export const getProductsInWarehouse = async ({ seller_cd = 'ABC', delivery_date, hic_start = '001', hic_end = '999' } = {}) => {
  const url = `${API_BASE}/products-in-warehouse?seller_cd=${encodeURIComponent(seller_cd)}&delivery_date=${encodeURIComponent(delivery_date)}&hic_start=${encodeURIComponent(hic_start)}&hic_end=${encodeURIComponent(hic_end)}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Products fetch failed: ${res.status}`);
  const data = await res.json();
  // try common shapes: array or { data: [...] }
  const list = Array.isArray(data) ? data : (data.data || data.products || []);
  return list.map((p, idx) => ({
    id: p.id || `api-${p.MEISEI_HINMEI_CD || p.code || idx}`,
    MEISEI_HINMEI_CD: p.MEISEI_HINMEI_CD ?? p.code ?? p.meisei_code ?? '',
    GRADE: p.GRADE ?? p.grade ?? '',
    SIZE: p.SIZE ?? p.size ?? '',
    PRODUCTION: p.PRODUCTION ?? p.production ?? '',
    QUANTITY: Number(p.QUANTITY ?? p.quantity ?? p.qty ?? 0),

    // Optional fields (if provided by backend)
    package: p.package ?? p.PACKAGE ?? p.cargo_form ?? p.cargoForm ?? null,
    ryome: p.ryome ?? p.RYOME ?? p.weight ?? p.WEIGHT ?? p.quantity_unit ?? p.quantityUnit ?? null,
  }));
};
